import * as React from 'react'

interface BannerContextInterface {
  hasBanner: boolean
}

const BannerContext = React.createContext<BannerContextInterface | null>(null)

export const BannerProvider: React.FC<{ children: React.ReactNode; hasBanner: boolean }> = ({
  children,
  hasBanner,
}) => {
  return <BannerContext.Provider value={{ hasBanner }}>{children}</BannerContext.Provider>
}

export const useBannerContext = () => {
  const context = React.useContext(BannerContext)
  if (!context) {
    return { hasBanner: false }
  }
  return context
}
